module.exports = __webpack_public_path__ + "img/medal5.66a2402b.png";